import React, { Component } from 'react'
import { connect } from 'react-redux'
import SummaryOverview from './SummaryOverview'
import './summary.scss'
import PropTypes from 'prop-types'
import moment from '../../helpers/momentUtils'
import Icon from '../../components/Icon/Icon'
import Loading from '../../components/Loading/Loading'
import FooterButton from '../../components/FooterButton/FooterButton'
import Alert from '../../components/Alert/Alert.js'
import Container from '../../components/Container/Container'
import getStaticData from '../../helpers/getStaticData'
import { tagSummaryPage } from '../../helpers/tag/dynamicPageview'
import { requestSubmitForm } from '../../actions/submitting'
import getPaxSummary from '../../helpers/getPaxSummary'
class Summary extends Component {
  state = {
    inboundRouteId: '',
    outboundRouteId: '',
  }

  constructor(props) {
    super(props)
    const { searchDetails } = props
    this.state = {
      inboundRouteId: `${
        !searchDetails.isMultipleDestination
          ? searchDetails.primary.inboundAirport.key
          : searchDetails.secondary.outboundAirport.key
      }-${
        !searchDetails.isMultipleDestination
          ? searchDetails.primary.outboundAirport.key
          : searchDetails.secondary.inboundAirport.key
      }`,
      outboundRouteId: `${searchDetails.primary.outboundAirport.key}-${
        searchDetails.primary.inboundAirport.key
      }`,
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    tagSummaryPage()
  }

  componentDidUpdate() {
    const { submitting, history } = this.props
    if (submitting.status === 'success') {
      history.push('/success')
    }
  }

  getInboundFlights = () => {
    const { searchDetails, flightOffers } = this.props
    const { inboundRouteId } = this.state
    if (searchDetails.isSingleFlight) return []
    return flightOffers.selectedFlights
      .find(route => route.routeId === inboundRouteId)
      .flights.map(flight => ({ ID: flight.id }))
  }

  getOutboundFlights = () => {
    const { flightOffers } = this.props
    const { outboundRouteId } = this.state
    return flightOffers.selectedFlights
      .find(route => route.routeId === outboundRouteId)
      .flights.map(flight => ({ ID: flight.id }))
  }

  getSSRs = () => {
    const { ancillaries } = this.props
    return Object.keys(ancillaries).reduce(
      (x, key) =>
        ancillaries[key].value > 0
          ? [
              ...x,
              {
                Quantity: ancillaries[key].value,
                ID: ancillaries[key].key,
              },
            ]
          : [...x],
      []
    )
  }

  getApiPayload = () => {
    const groupOffersApiConfig = getStaticData('groupofferrequest')
    const { bookerDetails, groupDetails } = this.props

    return {
      caseTypeID: groupOffersApiConfig.caseTypeID,
      processID: groupOffersApiConfig.processID,
      content: {
        Contact: {
          Salutation: bookerDetails.salutation,
          FirstName: bookerDetails.firstName,
          LastName: bookerDetails.lastName,
          Email: bookerDetails.emailAddress,
          PhoneNumber: bookerDetails.phoneNumber,
          CountryCode: bookerDetails.countryCode,
        },
        GroupBookingRequest: {
          GroupName: groupDetails.groupName,
          BookingChannel: groupOffersApiConfig.BookingChannel,
          CultureCode: groupOffersApiConfig.cultureCode,
          Company: bookerDetails.company,
          Party: {
            Adult: groupDetails.party.find(x => x.key === 'adults').value,
            Children: groupDetails.party.find(x => x.key === 'children').value,
            Infant: groupDetails.party.find(x => x.key === 'babies').value,
          },
          SSRs: this.getSSRs(),
          OutboundFlight: this.getOutboundFlights(),
          InboundFlight: this.getInboundFlights(),
        },
      },
    }
  }

  onSubmit = () => {
    this.props.requestSubmitForm(this.getApiPayload())
  }

  render() {
    const {
      flightOffers,
      searchDetails,
      ancillaries,
      groupDetails,
      bookerDetails,
      submitting,
      content,
    } = this.props
    const { inboundRouteId, outboundRouteId } = this.state
    const bookerDetailsLabels = content('Booker Details')
    const ancillariesLabels = content('Ancillaries')
    const summaryLabels = content('Summary')
    const groupDetailsLabels = content('Group Details')
    const { isSingleFlight, isMultipleDestination } = searchDetails
    const fullPhoneNumber = `${bookerDetails.countryCode} ${
      bookerDetails.phoneNumber
    }`

    return (
      <Container paddedBottom>
        {submitting.status === 'failed' && (
          <Alert type="error">{summaryLabels['Generic Error Message']}</Alert>
        )}
        {submitting.isFetching && <Loading backdrop={submitting.isFetching} />}
        <header>
          <h1>{summaryLabels.Heading}</h1>
        </header>
        <div className="summary">
          <header>
            <h3 className="summary__title">
              <Icon name="outbound" className="-blue summary__icon" />
              {`${searchDetails.primary.outboundAirport.label} - ${
                searchDetails.primary.inboundAirport.label
              }`}
            </h3>
          </header>
          <div className="summary__body">
            <table>
              <tbody>
                {flightOffers.selectedFlights
                  .find(function(route) {
                    return route.routeId === outboundRouteId
                  })
                  .flights.map(flight => (
                    <tr key={flight.id}>
                      <td>
                        <h4>
                          {`${moment(flight.departureDateTime).format(
                            'dddd'
                          )} ${moment(flight.departureDateTime).format(
                            'D'
                          )} ${moment(flight.departureDateTime).format(
                            'MMMM'
                          )}`}
                        </h4>
                      </td>
                      <td>
                        <p>
                          {`${moment(flight.departureDateTime).format(
                            'HH:mm'
                          )} - ${moment(flight.arrivalDateTime).format(
                            'HH:mm'
                          )}`}
                        </p>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        {!isSingleFlight && (
          <div className="summary">
            <header>
              <h3 className="summary__title">
                <Icon name="inbound" className="-blue summary__icon" />
                {`${
                  !isMultipleDestination
                    ? searchDetails.primary.inboundAirport.label
                    : searchDetails.secondary.outboundAirport.label
                } - ${
                  !isMultipleDestination
                    ? searchDetails.primary.outboundAirport.label
                    : searchDetails.secondary.inboundAirport.label
                }`}
              </h3>
            </header>
            <div className="summary__body">
              <table>
                <tbody>
                  {flightOffers.selectedFlights
                    .find(function(route) {
                      return route.routeId === inboundRouteId
                    })
                    .flights.map(flight => (
                      <tr key={flight.id}>
                        <td>
                          <h4>
                            {`${moment(flight.departureDateTime).format(
                              'dddd'
                            )} ${moment(flight.departureDateTime).format(
                              'D'
                            )} ${moment(flight.departureDateTime).format(
                              'MMMM'
                            )}`}
                          </h4>
                        </td>
                        <td>
                          <p>
                            {`${moment(flight.departureDateTime).format(
                              'HH:mm'
                            )} - ${moment(flight.arrivalDateTime).format(
                              'HH:mm'
                            )}`}
                          </p>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
        {this.getSSRs().length > 0 && (
          <SummaryOverview
            title={ancillariesLabels.Heading}
            icon="suitcase"
            content={Object.keys(ancillaries).reduce((x, key) => {
              const ancillary = ancillaries[key]
              return {
                ...x,
                [ancillariesLabels[ancillary.labelId]]: ancillary.value,
              }
            }, {})}
          />
        )}
        <SummaryOverview
          title={bookerDetailsLabels.Heading}
          icon="mainbooker"
          content={{
            [bookerDetailsLabels.Firstname]: bookerDetails.firstName,
            [bookerDetailsLabels.Lastname]: bookerDetails.lastName,
            [bookerDetailsLabels.Email]: bookerDetails.emailAddress,
            [bookerDetailsLabels['Phone number']]: fullPhoneNumber,
            [bookerDetailsLabels.Company]: bookerDetails.Company,
          }}
        />
        <SummaryOverview
          title={groupDetailsLabels.Heading}
          icon="groups"
          content={{
            [groupDetailsLabels['Group name']]: groupDetails.groupName,
            [groupDetailsLabels['Number of passengers']]: getPaxSummary(
              groupDetails.party
            ),
          }}
        />
        <FooterButton
          buttonContent={summaryLabels['Submit Button Label']}
          backButtonContent={summaryLabels['Return Button Label']}
          backButtonLink="/group-details"
          buttonAction={this.onSubmit}
          iconName="arrow-right"
        />
      </Container>
    )
  }
}
Summary.propTypes = {
  submitting: PropTypes.object,
  bookerDetails: PropTypes.object,
  ancillaries: PropTypes.object,
  searchDetails: PropTypes.object,
  flightOffers: PropTypes.object,
  groupDetails: PropTypes.shape({
    groupName: PropTypes.string,
    party: PropTypes.array,
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  content: PropTypes.func,
  requestSubmitForm: PropTypes.func,
}

const mapStateToProps = state => {
  const {
    groupDetails,
    flightOffers,
    searchDetails,
    bookerDetails,
    ancillaries,
    submitting,
  } = state
  return {
    bookerDetails,
    groupDetails,
    ancillaries,
    flightOffers,
    searchDetails,
    submitting,
  }
}

const mapDispatchToProps = {
  requestSubmitForm,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Summary)
